<template>
  <div class="row-content" style="padding: 1.25rem">
    <div class="row-title">{{propsOrgName}}等级培训班统计（2019年至今）<span class="title" style="color: #FAC858; margin-left: 2rem">总数量： <span style="font-size:18px">{{allNumber}} </span></span><span class="sutNum" v-if="numStatisticalStuAll">/ {{numStatisticalStuAll}}人</span></div>
    <div class="data-wrapper" style="display:block;">
      <div style="display:flex">
        <div :class="{'data-item':true, tooltip : numStatisticalStu.D }">
          <div class="data num_data">{{ numStatistical.D || '--' }}</div>
          <div class="data-title">D级</div>
          <div class="tooltiptext">
            <div>{{ numStatisticalStu.D }} 人</div>
          </div>
        </div>
        <div :class="{'data-item':true, tooltip : numStatisticalStu.C }">
          <div class="data num_data">{{ numStatistical.C || '--' }}</div>
          <div class="data-title">C级</div>
          <div class="tooltiptext">
            <div>{{ numStatisticalStu.C }} 人</div>
          </div>
        </div>
        <div :class="{'data-item':true, tooltip : numStatisticalStu.B }">
          <div class="data num_data">{{ numStatistical.B || '--' }}</div>
          <div class="data-title">B级</div>
          <div class="tooltiptext">
            <div>{{ numStatisticalStu.B }} 人</div>
          </div>
        </div>
        <div :class="{'data-item':true, tooltip : numStatisticalStu.A }">
          <div class="data num_data" >{{ numStatistical.A || '--' }}</div>
          <div class="data-title">A级</div>
          <div class="tooltiptext">
            <div>{{ numStatisticalStu.A }} 人</div>
          </div>
        </div>
        <div :class="{'data-item':true, tooltip : numStatisticalStu.PRO }">
          <div class="data num_data">{{ numStatistical.PRO || '--' }}</div>
          <div class="data-title">职业级</div>
          <div class="tooltiptext">
            <div>{{ numStatisticalStu.PRO }} 人</div>
          </div>
        </div>
      </div>
      <div style="display:flex;margin-top:5px">
        <div :class="{'data-item':true, tooltip : numStatisticalStu.GC }">
          <div class="data num_data">{{ numStatistical.GC || '--' }}</div>
          <div class="data-title">守门员C级</div>
          <div class="tooltiptext">
            <div>{{ numStatisticalStu.GC }} 人</div>
          </div>
        </div>
        <div :class="{'data-item':true, tooltip : numStatisticalStu.GB }">
          <div class="data num_data">{{ numStatistical.GB || '--' }}</div>
          <div class="data-title">守门员B级</div>
          <div class="tooltiptext">
            <div>{{ numStatisticalStu.GB }} 人</div>
          </div>
        </div>
        <div :class="{'data-item':true, tooltip : numStatisticalStu.GA }">
          <div class="data num_data">{{ numStatistical.GA || '--' }}</div>
          <div class="data-title">守门员A级</div>
          <div class="tooltiptext">
            <div>{{ numStatisticalStu.GA }} 人</div>
          </div>
        </div>
        <div :class="{'data-item':true, tooltip : numStatisticalStu.F1 }">
          <div class="data num_data">{{ numStatistical.F1 || '--' }}</div>
          <div class="data-title">体能L1级</div>
          <div class="tooltiptext">
            <div>{{ numStatisticalStu.F1 }} 人</div>
          </div>
        </div>
        <div :class="{'data-item':true, tooltip : numStatisticalStu.F2 }">
          <div class="data num_data">{{ numStatistical.F2 || '--' }}</div>
          <div class="data-title">体能L2级</div>
          <div class="tooltiptext">
            <div>{{ numStatisticalStu.F2 }} 人</div>
          </div>
        </div>
      </div>
  
    </div>
  </div>
</template>

<script>

export default {
  props: {
    // orgId
    numStatistical: {
      type: Object,
      required: true,
      default: {
        A: 0,
        B: 0,
        C: 0,
        D: 0,
      },
    },
    // orgId
    numStatisticalStu: {
      type: Object,
      required: true,
      default: {
        A: 0,
        B: 0,
        C: 0,
        D: 0,
      },
    },
    propsOrgName: {
      type: String,
      required: false,
      default: '',
    }
  },
  computed: {
    year() {
      const year = new Date().getFullYear();
      return year;
    },

    allNumber() {
      let allCounts = 0;
      for (let key in this.numStatistical) {
        allCounts += this.numStatistical[key]
      }
      return allCounts
//      const { A, B, C, D,F1 ,GC } = this.numStatistical;
//      return A + B + C + D + F1 ? A + B + C + D + F1 + GC : 0;
    },
    numStatisticalStuAll() {
      let allCounts = 0;
      for (let key in this.numStatisticalStu) {
        allCounts += this.numStatisticalStu[key]
      }
      return allCounts
    },

    // 测试数据
    orgId() {
      const { id } = this.$route.query;
      return id;
    },
  },
  data() {
    return {
      loading: false,
  
    };
  },

  methods: {
  
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.row-content
  position absolute
  top -4rem
  right -1.5rem
  bottom -0.875rem
  left -5.5rem
  padding 1.25rem 2rem
.row-title
  color #68d8fe
  font-weight 600
  font-size 16px
  margin-bottom 0.4rem
  display flex
  align-items center
  .sutNum
    font-size 12px
    margin-left 5px
    color #FAC858
.data-wrapper
  display flex
  flex-wrap wrap
  .data-item
    flex 1
    font-size 12px
    text-align center
    .data
      font-size 26px
    .num_data
      font-size 20px !important
    .data-title
      color #4c9bfd
      margin-top 5px
  .tooltip {
    position: relative;
    display: inline-block;
    cursor: pointer;
  }
  .tooltiptext {
    visibility: hidden;
    width: 70px;
    height: 35px; /* 设置高度为50px */
    line-height: 35px; /* 文字垂直居中，假设单行文本 */
    background-color: rgba(50, 50, 50, 0.7);
    color: #fff;
    text-align: center;
    padding: 0; /* 移除默认padding以精确控制高度 */
    border-radius: 6px;
    font-size:13px;
    /* 改变定位使工具提示出现在右侧 */
    position: absolute;
    z-index: 1;
    top: 50%; /* 使工具提示垂直居中 */
    right: -35%; /* 放置在触发元素右侧 */
    transform: translateY(-50%); /* 通过transform实现垂直居中 */
    
    /* 添加淡入淡出效果 */
    opacity: 0;
    transition: opacity 0.3s;
  }
  /* Tooltip arrow */
  .tooltiptext::after {
    content: "";
    position: absolute;
    top: 40%; /* At the bottom of the tooltip */
    right: 100%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color:  transparent rgba(50, 50, 50, 0.7) transparent transparent;
  }
  
  /* Show the tooltip text when you mouse over the tooltip container */
  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
</style>
